import { type ComponentPropsWithRef, type ComponentType, type ElementType, type ForwardedRef, forwardRef } from 'react';

import clsx from 'clsx';

import { ChevronRight } from '../Icons';
import { Link } from '../Link';

import { Default } from './Default';

import styles from './SideBar.module.scss';

type SidebarLinkProps<E extends ElementType = 'a'> = ComponentPropsWithRef<E> &
  ElementType<HTMLElement> & {
    icon: ComponentType;
    isActive?: boolean;
    supressIcon?: boolean | 'open';
    children: string;
    as?: ElementType;
  };

export const SidebarLink = forwardRef(
  (
    {
      children,
      icon = Default,
      isActive = false,
      supressIcon = false,
      ...sidebarLinkProps
    }: SidebarLinkProps<ElementType>,
    ref: ForwardedRef<ElementType<HTMLElement>>,
  ) => {
    const Icon = icon;

    return (
      <Link
        className={clsx(styles.link, {
          [styles.active]: isActive,
          [styles['supress-icon']]: supressIcon,
          [styles['supress-icon-open']]: supressIcon === 'open',
        })}
        asButton={false}
        variant="primary"
        ref={ref}
        {...sidebarLinkProps}
      >
        <Icon />
        <div className={clsx(styles.text)}>{children}</div>
        <ChevronRight className={clsx(styles.chevron)} />
      </Link>
    );
  },
);
